import React from 'react';
import {
  FaAngleDoubleRight,
  FaArrowRight,
  FaCheckCircle,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const DomesticInternationalToursDetails = () => {
  return (
    <>
      {/* ===================== Service Details Area start ===================== */}
      <div className="service-area pd-top-120 pd-bottom-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-12">
              <div className="td-sidebar service-sidebar">
                <div className="widget widget_catagory">
                  <h5 className="widget-title">
                    <FaArrowRight /> All Service lists
                  </h5>
                  <ul className="catagory-items">
                    <li>
                      <Link to="/AirTicketing"> Air Ticketing</Link>
                    </li>
                    <li>
                      <Link to="/TravelInsurance"> Travel Insurance</Link>
                    </li>
                    <li>
                      <Link to="/DomesticInternationalTours"> Domestic & International Tours</Link>
                    </li>
                     <li>
                      <Link to="/MICE"> MICE</Link>
                     </li>
                     <li>
                     <Link to="/PassportVisa"> Passport & Visa Assistance</Link>
                     </li>
                     <li>
                       <Link to="/HotelBooking"> Hotel Booking </Link>
                     </li>
                  </ul>
                </div>
                <div className="widget widget_author text-center">
                  <div className="thumb">
                    <img src="assets/img/about/9.png" alt="img" />
                  </div>
                  
                </div>
               
              </div>
            </div>
            <div className="col-lg-8">
              <div className="blog-details-page-content">
                <div className="single-blog-inner mb-0">
                  <div className="thumb">
                    <img src="assets/img/banner3.jpg" alt="img" />
                  </div>
                  <div className="details">
                    <h4>
                    Explore India & the World with Customized Tour Packages
                    </h4>
                    <p>
                    From serene beaches to majestic mountains, historic landmarks to cultural hotspots — we curate unforgettable holiday experiences. Bhavanya Travel Mart Pvt Ltd specializes in personalized 
                    domestic and international tour packages that suit every budget and interest.
                    </p>
                   
                    
                    <h4>Popular Destinations:</h4>
                   
                    <div className="row">
                      <div className="col-md-12">
                        <ul className="single-list-inner style-check style-check mb-3">
                          <li>
                            <FaCheckCircle />Domestic: Kerala, Goa, Himachal, Rajasthan, North-East, Andaman
                          </li>
                          <li>
                            <FaCheckCircle /> International: Dubai, Singapore, Thailand, Europe, Maldives, USA
                          </li>
                         
                        </ul>
                      </div>

                      <div className="details">
                    <Link className="btn btn-base border-radius-5" to="tel:6363169466">
                    Plan your dream vacation today !
                    </Link>
                  </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ===================== Service Details Area End ===================== */}
    </>
  );
};

export default DomesticInternationalToursDetails;
